import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';

import * as jspdf from 'jspdf';
import { ContentService } from 'src/app/shared/services/content.service';
import {environment} from '../../../environments/environment';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

declare const downloadPdfToIframe: any;

@Component({
  selector: 'app-ipsa-dashboard',
  templateUrl: './ipsa-dashboard.component.html',
  styleUrls: ['./ipsa-dashboard.component.scss']
})
export class IpsaDashboardComponent implements OnInit {
  @ViewChild('iframe', { static: false }) iframe!: ElementRef<HTMLIFrameElement>;
  powerBIiFrameLink: any | SafeResourceUrl;


  constructor(public router: Router, private contentService: ContentService, private sanitizer: DomSanitizer) {
    const unSanitisedURL = environment?.powerBIlink;

    // Sanitizing the URL to prevent security vulnerabilities
    this.powerBIiFrameLink = this.sanitizer.bypassSecurityTrustResourceUrl(unSanitisedURL);
   }

  ngOnInit(): void {
  }

  backToForm(): void {
    this.router.navigate(['/prism']);
  }

  generatePdf(): void{
    window.print();
  }



  convertIframeToPdf(iframe: HTMLIFrameElement, filename: string, callback: (success: boolean) => void): void {
    const iframeWindow = iframe.contentWindow;
    if (iframeWindow) {
        const iframeDocument = iframeWindow.document;
        if (iframeDocument) {
          const body = iframeDocument.body;

          new (window as any).html2canvas(body, { scrollY: -window.scrollY }).then((canvas: any) => {
            const imgData = canvas.toDataURL('image/png');
            const pdf = new jspdf.jsPDF();

            const imgProps = pdf.getImageProperties(imgData);
            const pdfWidth = pdf.internal.pageSize.getWidth();
            const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;

            pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
            pdf.save(filename + '.pdf');

            callback(true); // PDF generation successful
          })
          .catch((error: any) => {
            callback(false); // PDF generation failed
          });
        } else {
          callback(false); // PDF generation failed
        }
    } else {
      callback(false); // PDF generation failed
    }
  }



}
